import React, { PureComponent, Fragment } from 'react';

import {
  PieChart,
  Pie,
  ResponsiveContainer,
  Cell,
  LineChart,
  Line
} from 'recharts';
import {
  Metric,
  Error
} from './../../../Utils/Utils.js';
import numeral from './../../../../../node_modules/numeraljs/numeral.js';
import Heading from './../../../Elements/Heading';

const OPEN_COLORS = [
  '#16DE85',
  '#f4f4f4'
];

const CLICK_COLORS = [
  '#16C8DE',
  '#f4f4f4'
];

class EmailSummary extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />
    }

    return (
      <Fragment>

        <div className="row mt-3">
          <div className="col-6 col-sm-6 col-md-6">
            <Heading size={6} className={'mb-1'}>
              Total Subs
              </Heading>
            <Metric {...data.total} size={'md'} />
          </div>

          <div className="col-6 col-sm-6 col-md-6">
            <Heading size={6} className={'mb-1'}>
              New Last 7 Days
             </Heading>
            <Metric {...data.new} size={'md'} />

            <LineChart height={35} width={160} data={data.spark}>
              <Line type='linear' dataKey='value' stroke='#000000' dot={false} />
            </LineChart>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-6">
            <Heading size={6} className={'mb-1'}>
              Open Rate Last 7 Days
             </Heading>

            <ResponsiveContainer height={220}>
              <PieChart height={150}>
                <Pie dataKey="value" startAngle={180} endAngle={0} data={data.open_rate_7} outerRadius="100%" innerRadius="80%">
                  {
                    data.open_rate_7.map((entry, index) => (
                      <Cell key={`cell-${entry}`} fill={CLICK_COLORS[index]} />
                    ))
                  }
                </Pie>
                <text x="50%" y="40%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__primary">
                  {numeral(data.open_rate_7[0].value).divide(100).format('%')}
                </text>
              </PieChart>
            </ResponsiveContainer>

            <div className="piechart-metric__secondary">
              <h6 className="text-muted text-center">List Monthly Avg</h6>
              {numeral(data.open_rate_30).divide(100).format('%')}
            </div>
          </div>

          <div className="col-6">

            <Heading size={6} className={'mb-1'}>
              Click Rate Last 7 Days
             </Heading>

            <ResponsiveContainer height={220}>
              <PieChart height={150}>
                <Pie dataKey="value" startAngle={180} endAngle={0} data={data.click_rate_7} outerRadius="100%" innerRadius="80%">
                  {
                    data.click_rate_7.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={OPEN_COLORS[index]} />
                    ))
                  }
                </Pie>
                <text x="50%" y="40%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__primary">
                  {numeral(data.click_rate_7[0].value).divide(100).format('%')}
                </text>
              </PieChart>
            </ResponsiveContainer>

            <div className="piechart-metric__secondary">
              <h6 className="text-muted text-center">List Monthly Avg</h6>
              {numeral(data.click_rate_30).divide(100).format('%')}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default EmailSummary
